"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtpVerificationModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var auth_1 = require("firebase/auth");
var react_1 = require("react");
var countries_1 = require("../constants/countries");
var auth_2 = require("../features/apis/auth");
var firebase_1 = require("../utils/firebase");
var OtpVerificationModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, branding = _a.branding, siteName = _a.siteName, cellNumber = _a.cellNumber, country = _a.country, email = _a.email, onVerificationSuccess = _a.onVerificationSuccess, onBackToSignup = _a.onBackToSignup, developmentOtp = _a.developmentOtp, signupData = _a.signupData;
    var _b = (0, react_1.useState)(["", "", "", "", "", ""]), otp = _b[0], setOtp = _b[1];
    var _c = (0, react_1.useState)(""), error = _c[0], setError = _c[1];
    var _d = (0, react_1.useState)(60), resendTimer = _d[0], setResendTimer = _d[1];
    var _e = (0, react_1.useState)(false), canResend = _e[0], setCanResend = _e[1];
    var _f = (0, react_1.useState)(false), isSubmitting = _f[0], setIsSubmitting = _f[1];
    var isSubmittingRef = (0, react_1.useRef)(false);
    var inputRefs = (0, react_1.useRef)([]);
    // Development environment check
    var isDevEnv = ["LOCAL", "DEV"].includes(process.env.ENVIRONMENT || "");
    var _g = (0, auth_2.useSkyAuthVerifyOtpMutation)(), verifyOtp = _g[0], isVerifyLoading = _g[1].isLoading;
    var _h = (0, auth_2.useSkyAuthSendOtpMutation)(), sendOtp = _h[0], isResendLoading = _h[1].isLoading;
    var _j = (0, auth_2.useSkyAuthSignupMutation)(), skySignup = _j[0], isSignupLoading = _j[1].isLoading;
    // Initialize timer when modal opens
    (0, react_1.useEffect)(function () {
        if (isOpen) {
            setResendTimer(60);
            setCanResend(false);
            setIsSubmitting(false); // Reset submission state
            isSubmittingRef.current = false; // Reset ref too
            // Don't send OTP here - it's already sent in signup modal
        }
    }, [isOpen]);
    // Auto-fill OTP in development mode
    (0, react_1.useEffect)(function () {
        if (isOpen &&
            developmentOtp &&
            isDevEnv &&
            !isSubmitting &&
            !isSubmittingRef.current) {
            var otpArray = developmentOtp.padEnd(6, "0").slice(0, 6).split("");
            setOtp(otpArray);
            // Show development indicator
            setError("");
            // Auto-verify after a short delay to show the filled OTP
            setTimeout(function () {
                if (!isSubmitting && !isSubmittingRef.current) {
                    handleVerify(developmentOtp);
                }
            }, 1500); // Increased delay to avoid race conditions
        }
    }, [isOpen, developmentOtp]);
    // Countdown timer for resend
    (0, react_1.useEffect)(function () {
        var interval;
        if (resendTimer > 0 && !canResend) {
            interval = setInterval(function () {
                setResendTimer(function (prev) {
                    if (prev <= 1) {
                        setCanResend(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return function () {
            if (interval)
                clearInterval(interval);
        };
    }, [resendTimer, canResend]);
    // Focus first input when modal opens
    (0, react_1.useEffect)(function () {
        var _a;
        if (isOpen && inputRefs.current[0]) {
            (_a = inputRefs.current[0]) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [isOpen]);
    var sendOtpToPhone = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result_1, otpArray, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, sendOtp({
                            name: (signupData === null || signupData === void 0 ? void 0 : signupData.name) || "User",
                            cell_phone: {
                                calling_code: country.calling_code,
                                country_code: country.code,
                                number: cellNumber,
                            },
                        }).unwrap()];
                case 1:
                    result_1 = _c.sent();
                    // In development mode, auto-fill OTP if available in response
                    if (isDevEnv && ((_a = result_1 === null || result_1 === void 0 ? void 0 : result_1.data) === null || _a === void 0 ? void 0 : _a.developmentOtp)) {
                        otpArray = result_1.data.developmentOtp
                            .padEnd(6, "0")
                            .slice(0, 6)
                            .split("");
                        setOtp(otpArray);
                        // Auto-verify after a short delay
                        setTimeout(function () {
                            handleVerify(result_1.data.developmentOtp);
                        }, 1500);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    console.error("Error sending OTP:", error_1);
                    if (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) {
                        setError(error_1.message);
                    }
                    else if ((_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.data) === null || _b === void 0 ? void 0 : _b.message) {
                        setError(error_1.data.message);
                    }
                    else {
                        setError("Failed to send OTP. Please try again.");
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleOtpChange = function (index, value) {
        var _a;
        // Only allow digits
        if (!/^\d*$/.test(value))
            return;
        var newOtp = __spreadArray([], otp, true);
        newOtp[index] = value;
        setOtp(newOtp);
        // Clear error when user starts typing
        if (error)
            setError("");
        // Auto-focus next input
        if (value && index < 5) {
            (_a = inputRefs.current[index + 1]) === null || _a === void 0 ? void 0 : _a.focus();
        }
        // Auto-submit when all fields are filled (but not if already submitting)
        if (newOtp.every(function (digit) { return digit !== ""; }) &&
            newOtp.join("").length === 6 &&
            !isSubmitting &&
            !isSubmittingRef.current) {
            handleVerify(newOtp.join(""));
        }
    };
    var handleKeyDown = function (index, e) {
        var _a;
        // Handle backspace
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            (_a = inputRefs.current[index - 1]) === null || _a === void 0 ? void 0 : _a.focus();
        }
        // Handle paste
        if (e.key === "v" && (e.ctrlKey || e.metaKey)) {
            e.preventDefault();
            navigator.clipboard.readText().then(function (text) {
                var _a;
                var digits = text.replace(/\D/g, "").slice(0, 6);
                var newOtp = Array(6).fill("");
                for (var i = 0; i < digits.length; i++) {
                    newOtp[i] = digits[i];
                }
                setOtp(newOtp);
                // Focus the next empty field or the last field
                var nextIndex = Math.min(digits.length, 5);
                (_a = inputRefs.current[nextIndex]) === null || _a === void 0 ? void 0 : _a.focus();
                // Auto-verify if complete (but not if already submitting)
                if (digits.length === 6 && !isSubmitting && !isSubmittingRef.current) {
                    handleVerify(digits);
                }
            });
        }
    };
    var handleVerify = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (otpCode) {
            var verifyResult, signupResult, _a, error_2;
            var _b, _c, _d, _e;
            if (otpCode === void 0) { otpCode = otp.join(""); }
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (otpCode.length !== 6) {
                            setError("Please enter the complete 6-digit code");
                            return [2 /*return*/];
                        }
                        // Prevent multiple submissions
                        if (isVerifyLoading ||
                            isSignupLoading ||
                            isSubmitting ||
                            isSubmittingRef.current) {
                            return [2 /*return*/];
                        }
                        setIsSubmitting(true);
                        isSubmittingRef.current = true;
                        setError("");
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 10, , 11]);
                        return [4 /*yield*/, verifyOtp({
                                cell_phone: {
                                    calling_code: country.calling_code,
                                    country_code: country.code,
                                    number: cellNumber,
                                },
                                otp_code: otpCode,
                            }).unwrap()];
                    case 2:
                        verifyResult = _f.sent();
                        if (!verifyResult.success || !((_b = verifyResult.data) === null || _b === void 0 ? void 0 : _b.verified)) {
                            setError("Invalid code. Please try again.");
                            setOtp(["", "", "", "", "", ""]);
                            (_c = inputRefs.current[0]) === null || _c === void 0 ? void 0 : _c.focus();
                            setIsSubmitting(false);
                            isSubmittingRef.current = false;
                            return [2 /*return*/];
                        }
                        // Step 2: Complete Sky Lifestyle signup (Firebase + Let's Trade)
                        if (!signupData) {
                            setError("Signup data missing. Please go back and try again.");
                            setIsSubmitting(false);
                            isSubmittingRef.current = false;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, skySignup(__assign(__assign({}, signupData), { otp_code: otpCode })).unwrap()];
                    case 3:
                        signupResult = _f.sent();
                        if (!signupResult.success) return [3 /*break*/, 8];
                        _f.label = 4;
                    case 4:
                        _f.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, (0, auth_1.signInWithEmailAndPassword)(firebase_1.auth, signupData.email.toLowerCase().trim(), signupData.password)];
                    case 5:
                        _f.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        _a = _f.sent();
                        return [3 /*break*/, 7];
                    case 7:
                        onVerificationSuccess(signupResult.data);
                        return [3 /*break*/, 9];
                    case 8:
                        setError(signupResult.message || "Signup failed. Please try again.");
                        setIsSubmitting(false);
                        isSubmittingRef.current = false;
                        _f.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_2 = _f.sent();
                        setIsSubmitting(false);
                        isSubmittingRef.current = false;
                        if (error_2 === null || error_2 === void 0 ? void 0 : error_2.message) {
                            setError(error_2.message);
                        }
                        else if ((_d = error_2 === null || error_2 === void 0 ? void 0 : error_2.data) === null || _d === void 0 ? void 0 : _d.message) {
                            setError(error_2.data.message);
                        }
                        else {
                            setError("Failed to complete signup. Please try again.");
                        }
                        // Clear OTP inputs on error
                        setOtp(["", "", "", "", "", ""]);
                        (_e = inputRefs.current[0]) === null || _e === void 0 ? void 0 : _e.focus();
                        return [3 /*break*/, 11];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    var handleResendOtp = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setError("");
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, sendOtpToPhone()];
                case 2:
                    _b.sent();
                    setResendTimer(60);
                    setCanResend(false);
                    // Clear current OTP
                    setOtp(["", "", "", "", "", ""]);
                    (_a = inputRefs.current[0]) === null || _a === void 0 ? void 0 : _a.focus();
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _b.sent();
                    setError("Failed to resend OTP. Please try again.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    if (!isOpen)
        return null;
    var displayPhoneNumber = (0, countries_1.formatPhoneNumber)(cellNumber, country);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "fixed inset-0 z-50", children: [(0, jsx_runtime_1.jsx)("div", { className: "absolute inset-0 bg-black/50", onClick: onClose }), (0, jsx_runtime_1.jsxs)("div", { className: "absolute top-4 right-4 max-w-sm", children: [(0, jsx_runtime_1.jsx)("button", { onClick: onClose, className: "absolute top-0 -left-5 w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-lg z-10", style: { backgroundColor: branding.primaryColor }, children: "\u00D7" }), (0, jsx_runtime_1.jsx)("div", { className: "bg-white rounded-lg shadow-xl w-full max-h-[calc(100vh-2rem)] overflow-y-auto", children: (0, jsx_runtime_1.jsxs)("div", { className: "px-6 py-8", children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-2xl font-bold text-gray-900 mb-2", children: "Verify Phone Number" }), (0, jsx_runtime_1.jsxs)("p", { className: "text-sm text-gray-600 mb-6", children: ["We've sent a 6-digit verification code to ", displayPhoneNumber] }), isDevEnv && ((0, jsx_runtime_1.jsx)("div", { className: "mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg", children: (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-blue-600 font-medium", children: "\uD83D\uDD27 Development Mode: OTP will be auto-filled" }) })), error && ((0, jsx_runtime_1.jsx)("div", { className: "mb-4 p-3 bg-red-50 border border-red-200 rounded-lg", children: (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-red-600", children: error }) })), (0, jsx_runtime_1.jsxs)("div", { className: "space-y-6", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("label", { className: "block text-sm font-medium text-gray-900 mb-3", children: "Enter verification code" }), (0, jsx_runtime_1.jsx)("div", { className: "flex space-x-2 justify-center", children: otp.map(function (digit, index) { return ((0, jsx_runtime_1.jsx)("input", { ref: function (el) {
                                                            inputRefs.current[index] = el;
                                                        }, type: "text", inputMode: "numeric", pattern: "[0-9]", maxLength: 1, value: digit, onChange: function (e) { return handleOtpChange(index, e.target.value); }, onKeyDown: function (e) { return handleKeyDown(index, e); }, className: "w-12 h-12 text-center text-lg font-semibold border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent", style: {
                                                            "--tw-ring-color": branding.primaryColor,
                                                        } }, index)); }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "text-center", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-sm text-gray-600 mb-2", children: "Didn't receive the code?" }), canResend ? ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: handleResendOtp, disabled: isResendLoading, className: "text-sm font-medium hover:underline disabled:opacity-50", style: { color: branding.primaryColor }, children: isResendLoading ? "Sending..." : "Resend Code" })) : ((0, jsx_runtime_1.jsxs)("p", { className: "text-sm text-gray-500", children: ["Resend available in ", resendTimer, "s"] }))] }), (0, jsx_runtime_1.jsx)("button", { type: "button", onClick: function () { return handleVerify(); }, disabled: isVerifyLoading ||
                                                isSignupLoading ||
                                                isSubmitting ||
                                                otp.some(function (digit) { return !digit; }), className: "w-full py-3 px-4 text-white font-medium rounded-lg transition-colors duration-200 hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed", style: { backgroundColor: branding.primaryColor }, children: isSignupLoading
                                                ? "Creating Account..."
                                                : isVerifyLoading || isSubmitting
                                                    ? "Verifying..."
                                                    : "Verify & Create Account" }), (0, jsx_runtime_1.jsx)("div", { className: "text-center", children: (0, jsx_runtime_1.jsx)("button", { type: "button", onClick: onBackToSignup, className: "text-sm font-medium hover:underline", style: { color: branding.primaryColor }, children: "\u2190 Back to Sign Up" }) })] })] }) })] })] }));
};
exports.OtpVerificationModal = OtpVerificationModal;
